import { type AxiosResponse } from 'axios';
import { BASE_URL } from '@avanta/shared/constants/common';
import { type Department } from '@avanta/shared/types/departments';
import { getAnonymousTokenCookie } from '@avanta/shared/utils/storage';
import { service } from '../api';
import { getAnonymousToken } from '../auth';

const DEPARTMENTS_URL = `${BASE_URL}departments`;

export interface DepartmentServiceTypes {
  getDepartments: (centerId: string) => Promise<AxiosResponse<Department[]>>;
  getDepartment: (departmentId: string) => Promise<AxiosResponse<Department>>;
}

export const DepartmentService: DepartmentServiceTypes = {
  getDepartments: async centerId => {
    const anonymousToken =
      getAnonymousTokenCookie() || (await getAnonymousToken())?.data.access_token;
    return service.get(`${DEPARTMENTS_URL}/byCenter`, {
      headers: { Authorization: `Bearer ${anonymousToken}` },
      params: {
        centerId,
      },
    });
  },
  getDepartment: async departmentId => service.get(`${DEPARTMENTS_URL}/${departmentId}`),
};
